function getAdBlockerStatus(): string {
  if (window?.meso?.adblock?.enabled ?? true) {
    return 'enabled';
  }

  return 'disabled';
}

export function isInBrowser() {
  return typeof window !== 'undefined';
}

export function getAdBlockerEventParams() {
  const status = getAdBlockerStatus();

  return {
    referrer: `meso.adblocker.${status}`,
    linkName: `adblocker status: ${status}`,
  };
}
